
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karrycar",
      function () {
        return require("private-next-pages/karrycar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karrycar"])
      });
    }
  